import * as React from 'react';
import locales from "../locales";
import {Modal} from "antd";
import {ErrorResponse, ItemAlert, SaveItemAlertRequest} from "../api/dtos/dtos";
import ItemAlertForm from "./ItemAlertForm";
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from "../app/ApplicationContext";
import * as moment from 'moment';
import {toIsoString} from "../utils/date-utils";
import furoApi from "../api/FuroApi";
import {showSaveSuccessNotification} from "../utils/dialogs";
import {ErrorAlert} from "../common/ErrorAlert";

interface Props {
  alertId?: number;
  alert?: SaveItemAlertRequest;
  onAlertSaved: () => void;
  onAlertCanceled: () => void;
}

interface State {
  error?: ErrorResponse;
}

export const editAlertRequest = (alert: ItemAlert): SaveItemAlertRequest => ({
  itemId: alert.item.id!,
  name: alert.name,
  alertDate: alert.alertDate,
  handledDate: alert.handledDate,
  operationHours: alert.operationHours,
});

export const newAlertRequest = (itemId: number): SaveItemAlertRequest => ({
  itemId,
  name: '',
  alertDate: toIsoString(moment()),
  handledDate: null,
  operationHours: null
});

export class ItemAlertEditor extends React.Component<Props, {}> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  public state: State = {};

  public render(): React.ReactNode {
    const {alert} = this.props;
    const {error} = this.state;

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <Modal
          title={locales.edit_entry}
          visible={alert !== undefined}
          footer={null}
          onCancel={this.onFormCancel}
          destroyOnClose={true}
        >
          <>
            <ItemAlertForm
              alert={alert!}
              onFormSubmit={this.onFormSubmit}
              onFormCancel={this.onFormCancel}
            />
            <ErrorAlert style={{marginTop: '16px'}} error={error}/>
          </>
        </Modal>

      </>
    );
  }

  private onFormCancel = () => {
    this.props.onAlertCanceled();
  };

  private onFormSubmit = (request: SaveItemAlertRequest) => {
    const {alertId} = this.props;
    const savePromise = alertId
      ? furoApi.alerts.update(request, alertId)
      : furoApi.alerts.create(request);

    const promise = savePromise
      .then(this.onSaveSuccess)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onSaveSuccess = () => {
    this.setState({
      error: undefined,
    });
    showSaveSuccessNotification();
    this.props.onAlertSaved();
  };

  private onApiError = (error: ErrorResponse) => this.setState({error});
}


// WEBPACK FOOTER //
// ./src/alerts/ItemAlertEditor.tsx